import { render, staticRenderFns } from "./PersonalDetailsModal.vue?vue&type=template&id=bb0fd776&scoped=true&"
import script from "./PersonalDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./PersonalDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDetailsModal.vue?vue&type=style&index=0&id=bb0fd776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0fd776",
  null
  
)

export default component.exports